import { Toast } from '../../../../components/Common/Toast';
import { callAPI } from '../../../../services/api.service';
import { HTTPStatusEnum } from '../../../../interfaces/log.interface';
import { UserTypeEnum } from '../../../../interfaces/user.interface';


export const generateNewInviteLink = async (selectedPlanId?: string | null, selectedUserType: UserTypeEnum = UserTypeEnum.StandardUser, requirePayment: boolean = false) => {
  try {
    const response = await callAPI(`admin/user/invite-link`, {
      planId: selectedPlanId,
      userType: selectedUserType,
      free: !requirePayment
    });
    if (response?.status === HTTPStatusEnum.OK) {
      return response?.link;
    } else {
      Toast('Error generating invite link', true);
    }
  } catch (error) {
    Toast('Error generating invite link', true);
    throw error;
  }
};
